<template>
    <article
        class="i-credit-ratings"
        :class="{small: small}">
        <div class="i-credit-ratings__header-wrap">
            <h2
                class="i-credit-ratings__header"
                :title="creditRatingsData.name"
                v-html="creditRatingsData.name"></h2>
            <div
                v-if="creditRatingsData.tooltip"
                class="i-credit-ratings__tooltip">
                <div class="i-credit-ratings__tooltip-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02943 21 2.99999 16.9706 2.99999 12C2.99999 7.02946 7.02943 3.00002 12 3.00002C16.9706 3.00002 21 7.02946 21 12Z" fill="#999999"/>
                        <path d="M11 7.99998V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V7.99998C13 7.44769 12.5523 6.99998 12 6.99998C11.4477 6.99998 11 7.44769 11 7.99998Z" fill="#999999"/>
                        <path d="M11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071C13.0977 15.3165 13.0977 14.6834 12.7071 14.2929C12.3166 13.9023 11.6834 13.9023 11.2929 14.2929C10.9024 14.6834 10.9024 15.3165 11.2929 15.7071Z" fill="#999999"/>
                    </svg>
                </div>
                <p
                    class="i-credit-ratings__tooltip-text"
                    v-html="creditRatingsData.tooltip"></p>
            </div>
        </div>
        <div class="i-credit-ratings__wrap">
            <ul class="i-credit-ratings__list">
                <li
                    v-for="(item, i) in creditRatingsData.items"
                    :key="i"
                    class="i-credit-ratings__item">
                    <div
                        class="i-credit-ratings__icon">
                        <img
                            :src="item.icon_src"
                            :alt="item.values_ratings"
                            :title="item.values_ratings" />
                    </div>
                    <div class="i-credit-ratings__wrapper">
                        <span
                            class="i-credit-ratings__val"
                            v-html="item.values_ratings"></span>
                        <a
                            v-if="item.link_url"
                            class="i-credit-ratings__link"
                            :href="item.link_url"
                            :title="item.link_title"
                            target="_blank"
                            v-html="item.link_title"></a>
                    </div>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'Кредитные рейтинги',
        props: {
            creditRatingsData: {
                type: Object,
                default: () => {}
            },
            small: {
                type: Boolean,
                default: false
            }
        },
    }
</script>